import { size } from '../functions/size';

const custCollectionFunc = {
  size,
};

const customFunctions = {
  custCollectionFunc,
};

export const createContext = () => ({
  ...customFunctions,
});
